import React from 'react';
import PropTypes from 'prop-types';

import styles from './Reason.scss';

const ReasonPanel = ({ list, title }) => (
  <div className={styles.root}>
    <h3 className={styles.title}>{title}</h3>
    <div className={styles.purposePanel}>
      {list &&
        list.map((reason, index) => {
          const { icon, title: panelTitle, subTitle } = reason;

          return (
            <div className={styles.panel} key={index}>
              {icon}
              <h5>{panelTitle}</h5>
              <p>{subTitle}</p>
            </div>
          );
        })}
    </div>
  </div>
);

ReasonPanel.propTypes = {
  list: PropTypes.array.isRequired,
  title: PropTypes.string,
};

ReasonPanel.defaultProps = {
  title: '',
};

export default ReasonPanel;



// WEBPACK FOOTER //
// ./app/containers/Tutors/components/ReasonPanel/Reason.jsx